import { ActiveRecord, sources } from '@mysidewalk/active-record';
/**
 * @memberof customer-metadata
 * @property {number} id
 * @property {string} friendlyLongName
 * @property {string} friendlyShortName
 * @property {date} start
 * @property {string} systemName
 * @property {object} timeGroup
 */
class TimeElement extends ActiveRecord {
}
TimeElement.$AR = {
    url: '',
    SourceClass: sources.ActiveRecordJSONAPISource,
};
export default TimeElement;
